export default __webpack_public_path__ + "static/media/vimeo.0a258d1e.svg";